<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <amplify-authenticator v-bind:authConfig="authConfig"
        ></amplify-authenticator>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

export default {
  name: 'home',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      authConfig: {
        signUpConfig: {
          header: "Not available",
          hideAllDefaults: true,
        },
      }
    }
  },
  beforeCreate() {
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        this.$store.dispatch("tryAuthenticateUser");
        this.$router.push("/dashboard");
      }
    });

    Auth.currentAuthenticatedUser()
      .then(user => {
        void(user)
        this.$store.dispatch("tryAuthenticateUser");
        this.$router.push("/dashboard");
      })
      .catch(() => this.signedIn = false)
  },
}
</script>
